var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFileCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "file_copy_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#file_copy_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87858B",
  d: "M2.667 15.335c-.366 0-.68-.13-.941-.392a1.284 1.284 0 0 1-.392-.942V4.668h1.333v9.333h7.334v1.334H2.667Zm2.667-2.667c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.391-.941V2c0-.366.13-.68.391-.941.261-.261.575-.392.942-.392h4.667l4 4v6.667c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.942.392H5.334Zm4-7.333h3.333L9.334 2v3.334Z"
}))));
export default SvgFileCopy;